export default __webpack_public_path__ + "static/media/yImg.519bdb5d.png";